import BaseMindElementDataCalculation from "./BaseMindElementDataCalculation"
import MindElementType from "../../../../viewmodel/datatype/MindElementType";
import IconLayoutType from "../../../../viewmodel/datatype/IconLayoutType";
import TextAndIconAndLinkAndRemarksCalculation from "./TextAndIconAndLinkAndRemarksCalculation";
/**
 * ProjectName: MindMap
 * Created by tony on 2020/7/14
 * Copyright(c) 2020 mindyushu.com
 */
 
class TextAndIconAndLinkAndRemarksAndTaskCalculation extends TextAndIconAndLinkAndRemarksCalculation {

    constructor(data,nodeLayoutType) {
        super(data,nodeLayoutType);
    }

    calculate() {
        if (!this.data.isContainLinkContent() || !this.data.isContainRemarksContent() || this.data.taskContent == null) {
            return;
        }
        let textMindElementContent = this.getTextMindElementContent();
        let linkElementContent = this.data.linkElementContent;
        let remarksElementContent = this.data.remarksElementContent;

        let textRext = this.caluleTextCGRect();
        let textHeight = (textRext.height());
        linkElementContent.width = textHeight;
        linkElementContent.height = textHeight;
        remarksElementContent.width = textHeight;
        remarksElementContent.height = textHeight;

        let size = this.includeIconAndTextAndLinkAndRemarksAndTaskSize();
        let iconAndTextAndLinkAndRemarksSize = this.includeIconAndTextAndLinkAndRemarksSize();
        let layoutType = this.getIconLayout();
        let iconsSize = this.caluleIconElementSize();
        let marginPoint = this.getMargin(size);
        let marginX = marginPoint.left;
        let marginY = marginPoint.top;

        let iconElementContents = this.data.iconElementContents;
        if (iconElementContents == null || iconElementContents.length == 0) {
            textMindElementContent.x = marginX;
            textMindElementContent.y = marginY;
            return;
        }
        let textLinkRemarksSize = this.includeTextAndLinkAndRemarksSize();
        let iconLeft = 0;
        let iconTop = 0;
        let linkTextSpace = this.data.type == MindElementType.MAIN_SUBJECT || this.data.type == MindElementType.SUBJECT || this.data.type == MindElementType.CONTENT_GENERALIZATION ? (this.iconTextSpace) : 0;
        if (layoutType == IconLayoutType.LAYOUT_LEFT) {
            iconLeft = this.data.type == MindElementType.MAIN_SUBJECT || this.data.type == MindElementType.SUBJECT || this.data.type == MindElementType.CONTENT_GENERALIZATION ? (this.iconMargin) : 0;
            iconTop = (iconAndTextAndLinkAndRemarksSize.getHeight() - iconsSize.getHeight()) / 2;
            textMindElementContent.x = (iconsSize.getWidth() + this.iconTextSpace + this.iconMargin) + marginX;
            textMindElementContent.y = ((iconAndTextAndLinkAndRemarksSize.getHeight()) - textMindElementContent.height) / 2 + marginY;

            linkElementContent.x = textMindElementContent.x + textMindElementContent.width + linkTextSpace;
            linkElementContent.y = ((iconAndTextAndLinkAndRemarksSize.getHeight()) - linkElementContent.height) / 2 + marginY;
            remarksElementContent.x = linkElementContent.x + linkElementContent.width + (this.iconSpace);
            remarksElementContent.y = linkElementContent.y;

        } else if (layoutType == IconLayoutType.LAYOUT_RIGHT) {
            iconLeft = (iconAndTextAndLinkAndRemarksSize.getWidth() - iconsSize.getWidth() - this.iconMargin);
            iconTop = (iconAndTextAndLinkAndRemarksSize.getHeight() - iconsSize.getHeight()) / 2;
            textMindElementContent.x = marginX;
            textMindElementContent.y = ((iconAndTextAndLinkAndRemarksSize.getHeight()) - textMindElementContent.height) / 2 + marginY;

            linkElementContent.x = textMindElementContent.x + textMindElementContent.width + linkTextSpace;
            linkElementContent.y = ((iconAndTextAndLinkAndRemarksSize.getHeight()) - linkElementContent.height) / 2 + marginY;
            remarksElementContent.x = linkElementContent.x + linkElementContent.width + (this.iconSpace);
            remarksElementContent.y = linkElementContent.y;

        } else if (layoutType == IconLayoutType.LAYOUT_TOP) {
            iconLeft = (iconAndTextAndLinkAndRemarksSize.getWidth() - iconsSize.getWidth()) / 2;
            iconTop = (this.iconSpace);
            textMindElementContent.x = ((iconAndTextAndLinkAndRemarksSize.getWidth()) - (textLinkRemarksSize.getWidth())) / 2 + marginX;
            textMindElementContent.y = iconTop + (iconsSize.getHeight()) + marginY;

            linkElementContent.x = textMindElementContent.x + textMindElementContent.width + linkTextSpace;
            linkElementContent.y = textMindElementContent.y + ((textLinkRemarksSize.getHeight()) - linkElementContent.height) / 2;
            remarksElementContent.x = linkElementContent.x + linkElementContent.width + (this.iconSpace);
            remarksElementContent.y = linkElementContent.y;

        }
        for (let index = 0; index < iconElementContents.length; index++) {
            let iconCell = iconElementContents[index];
            if (index == 0) {
                iconCell.x = iconLeft + marginX;
            } else {
                iconCell.x = iconElementContents[index - 1].x + iconElementContents[index - 1].width + (this.iconSpace);
            }
            iconCell.y = iconTop + marginY;
        }
        
        let textEdgeInsets = this.getTextEdgeInsets();
        this.data.taskContent.x = marginX + textEdgeInsets.left;
        this.data.taskContent.y = textMindElementContent.y + textMindElementContent.height;
        this.data.taskContent.width = this.taskOriginalSize.getWidth();
        this.data.taskContent.height = this.taskOriginalSize.getHeight();

        this.setMindElementSize(size.getWidth(), size.getHeight(), marginPoint);
    }
}
export default TextAndIconAndLinkAndRemarksAndTaskCalculation
